<template>
  <nav class="navbar navbar-expand-lg navbar-dark fixed-top text-white nav-solid">
    <div class="container">
      <a v-scroll-to="{ el: '#app' }" class="navbar-brand clickable">
        <img src="@/assets/logo.png" class="mx-auto d-block img-circle-larger logo" alt="">
      </a>
      <button class="navbar-toggler" @click.prevent="toggle">
        <span class="navbar-toggler-icon"></span>
      </button>
        <div class="collapse navbar-collapse" :class="{ 'show': isOpen }">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a v-scroll-to="{ el: '#howitworks' }" class="nav-link clickable">Como Funciona?</a>
            </li>
            <li class="nav-item">
              <a v-scroll-to="{ el: '#steps', offset: -100 }" class="nav-link clickable">A Estratégia</a>
            </li>
            <li class="nav-item">
              <a v-scroll-to="{ el: '#benefits' }" class="nav-link clickable">Benefícios</a>
            </li>
            <!-- TODO: ACRESCENTAR LINK QUANDO TIVERMOS DEPOIMENTOS -->
            <!-- <li class="nav-item">
                <a href="#depoimentos" class="nav-link scrollSuave">Depoimentos</a>
            </li> -->
            <li class="nav-item">
              <a v-scroll-to="{ el: '#price' }" class="nav-link clickable">Nossos Planos</a>
            </li>
            <li class="nav-item">
              <a v-scroll-to="{ el: '#warranty', offset: -50 }" class="nav-link clickable">Garantia</a>
            </li>
            <li class="nav-item">
              <a v-scroll-to="{ el: '#faq' }" class="nav-link clickable">FAQ</a>
            </li>
            <!-- <li class="nav-item">
                <a href="#footer" class="nav-link scrollSuave">Contato</a>
            </li> -->
          </ul>
          <form class="form-inline my-2 my-lg-0">
            <a :href="loginLink" class="btn-login">Login</a>
          </form>
        </div>
      </div>
    </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    isOpen: false
  }),
  computed: {
    ...mapState(['loginLink'])
  },
  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
